import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..

const Sections = document.querySelectorAll('section > .container');
const Headings = document.querySelectorAll('.section__heading > *');
const Cols = document.querySelectorAll('.row > [class*="col-"], .row >  .col');
Sections.forEach((section) => {
    section.setAttribute('data-aos', 'fade-up');
    // section.classList.add('aos-item');
});
Headings.forEach((heading) => {
    heading.setAttribute('data-aos', 'fade-up');
    heading.setAttribute('data-aos-delay', 300);
    // section.classList.add('aos-item');
});
Cols.forEach((col) => {
    col.setAttribute('data-aos', 'fade-up');
    col.setAttribute('data-aos-delay', 100);
    // section.classList.add('aos-item');
    // console.log(col, i);
});

AOS.init();
